module.exports = __webpack_public_path__ + "img/login_bg.7d7a7d0b.png";